"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevelopmentStage = exports.isGammaStage = exports.isBetaStage = exports.isProdStage = exports.CURRENT_STAGE = exports.STAGES = void 0;
var STAGES;
(function (STAGES) {
    STAGES["DEVELOPMENT"] = "development";
    STAGES["DEV"] = "dev";
    STAGES["TEST"] = "test";
    STAGES["ESSP"] = "essp";
    STAGES["BETA"] = "beta";
    STAGES["GAMMA"] = "gamma";
    STAGES["PROD"] = "prod";
})(STAGES = exports.STAGES || (exports.STAGES = {}));
exports.CURRENT_STAGE = '{{Stage}}';
function isProdStage() {
    return exports.CURRENT_STAGE.toLowerCase() === STAGES.PROD;
}
exports.isProdStage = isProdStage;
function isBetaStage() {
    return exports.CURRENT_STAGE.toLowerCase() === STAGES.BETA;
}
exports.isBetaStage = isBetaStage;
function isGammaStage() {
    return exports.CURRENT_STAGE.toLowerCase() === STAGES.GAMMA;
}
exports.isGammaStage = isGammaStage;
function isDevelopmentStage() {
    return exports.CURRENT_STAGE.toLowerCase() === STAGES.DEVELOPMENT;
}
exports.isDevelopmentStage = isDevelopmentStage;
